import React, { useEffect, useRef, useState } from "react";
import { LogOut, UserCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import "./Profile.css";

/**
 * Profile dropdown for the signed-in user.
 */
const ProfileDropdown = () => {
  const [open, setOpen] = useState(false);
  const { user, role, logout } = useAuth();
  const containerRef = useRef(null);

  // Close when clicking outside or pressing Escape.
  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  const displayName = user?.name || user?.phone_number || "Account";
  const secondary = user?.email || user?.phone_number || "";

  return (
    <div className="profile-container" ref={containerRef}>
      <button
        onClick={() => setOpen((value) => !value)}
        className="profile-icon icon-button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account menu"
      >
        <UserCircle size={22} strokeWidth={1.7} />
      </button>

      {open && (
        <div className="dropdown-menu" role="menu">
          <div className="dropdown-info">
            <strong>{displayName}</strong>
            {secondary && <div className="email">{secondary}</div>}
            {role && <div className="profile-role">{role}</div>}
          </div>
          <button onClick={logout} className="logout-btn" role="menuitem">
            <LogOut size={15} strokeWidth={1.8} aria-hidden="true" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
